import React from 'react';

const Achievements = () => {
  const achievements = [
    "Semi-finalist (Top 68 among 5000+ participants) in HackOn with Amazon 2022",
    "Solved 600+ DSA problems in LeetCode, GFG and other platforms",
    "Finalist in Hack With CW (an international level Hackathon).",
    "Semi finalist in HACKNITP 3.0(Hackathon by NIT Patna).",
    "Semi finalist in Rapid Hackathon by Route Mobile."
  ];

  return (
    <section id="achievements" className="py-20 px-4 bg-gray-800">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">
          <span className="border-b-4 border-blue-400 pb-2">Achievements</span>
        </h2>
        <div className="max-w-2xl mx-auto">
          <ul className="space-y-4">
            {achievements.map((achievement, index) => (
              <li key={index} className="bg-gray-700 p-4 rounded-lg flex items-start">
                <span className="text-blue-400 mr-3 mt-1">✓</span>
                <span className="text-gray-300">{achievement}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Achievements;